const NoMatch: React.FC = () => {
  const error = new Error()
  error.name = "404"
  throw error
}

export default NoMatch
